//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.components')
        .directive('srsngRunningTasks', srsngRunningTasks);

    function srsngRunningTasks($interval) {

        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/components/running-tasks/running-tasks.html',
            controller: controller,
            link: link
        };

        function controller($scope, MockTask) {

            $scope.refresh = function () {

                $scope.tasks = MockTask.query();
            };

            $scope.refresh();
        }

        function link(scope, element, attrs) {
            // this is intentional override

        }
    }
})();

